import {
    Dialog,
    pxToRem,
    useAppDisplayModeContext,
    useStyles,
} from '@archipro-design/aria';
import type { TeamMemberView } from '@modules/professional/type/team-member';
import { useClickAway } from 'ahooks';
import { useRef } from 'react';

import * as S from './TeamMemberDetailsModalUpdated.style';
import TeamMemberModalContent from './TeamMemberModalContent';
import BottomDrawer from '~/modules/detail/components/bottom-drawer/BottomDrawer';

interface TeamMemberDetailsModalUpdatedProps {
    member: TeamMemberView;
    website: string;
    toggleModal: () => void;
    isOpen: boolean;
}

const TeamMemberDetailsModalUpdated = ({
    member,
    website,
    toggleModal,
    isOpen,
}: TeamMemberDetailsModalUpdatedProps) => {
    const { css } = useStyles();
    const modalRef = useRef(null);
    const { mobile: isMobile } = useAppDisplayModeContext();

    useClickAway(() => {
        toggleModal();
    }, [modalRef]);

    if (member === null) return null;

    const modalWidth = member.summary ? 1240 : 620;

    return (
        <>
            {isMobile ? (
                <BottomDrawer open={isOpen} toggleModal={toggleModal}>
                    <TeamMemberModalContent
                        website={website}
                        memberDetails={member}
                    />
                </BottomDrawer>
            ) : (
                <Dialog
                    ref={modalRef}
                    open={isOpen}
                    trapFocus={false}
                    header={null}
                    content={{
                        content: (
                            <TeamMemberModalContent
                                website={website}
                                memberDetails={member}
                                toggleModal={toggleModal}
                            />
                        ),
                        className: css(S.TeamMemberDialogContentWrapper),
                        style: { padding: '0' },
                    }}
                    footer={{
                        style: { padding: '0' },
                    }}
                    variables={{
                        border: 0,
                        rootBorderRadius: 0,
                        rootWidth: pxToRem(modalWidth),
                        padding: pxToRem(0),
                    }}
                />
            )}
        </>
    );
};

export default TeamMemberDetailsModalUpdated;
